// extracted by mini-css-extract-plugin
module.exports = {"inputRow":"InputArea_inputRow__1AGtI","recipientSelect":"InputArea_recipientSelect__vuhV-","alert":"InputArea_alert__2d9--"};